<section id="ticket-more" [ngClass]="{'dark': isDarkmode, 'light': !isDarkmode}">

  @if (!resize.isPortrait && isOpen) {
    <div id="closeMore" class="hover-bttn" (click)="close.emit(false)">
      <ion-icon name="fa-chevrons-left"></ion-icon>
    </div>
  }

  <ion-segment mode="ios" [value]="segmentValue" (ionChange)="segmentChanged($event)">
    <ion-segment-button layout="icon-start" value="settings">
      <ion-icon name="fa-gear"></ion-icon>
    </ion-segment-button>
    <ion-segment-button layout="icon-start"  value="appointments">
      <ion-icon name="fa-calendar"></ion-icon>
    </ion-segment-button>
    <ion-segment-button layout="icon-start"  value="files">
      <ion-icon name="fa-file"></ion-icon>
    </ion-segment-button>
    <ion-segment-button layout="icon-start"  value="times">
      <ion-icon name="fa-timer"></ion-icon>
    </ion-segment-button>
  </ion-segment>



  <ion-content NoScrollbar style="height: calc(100% - 30px)">
    @if (segmentValue === 'settings' || segmentValue === 'overview') {
      <app-ticket-detail-allgemein></app-ticket-detail-allgemein>
    }
    @if (segmentValue === 'appointments') {
      <ticket-detail-appointments></ticket-detail-appointments>
    }
    @if (segmentValue === 'times') {
      <app-ticket-detail-zeiten></app-ticket-detail-zeiten>
    }
    @if (segmentValue === 'files') {
      <app-ticket-detail-assets></app-ticket-detail-assets>
    }
  </ion-content>


</section>